import React, { useEffect, useState } from 'react'
import './Ofertas.css'
import { Link, useLocation } from 'react-router-dom'

const Ofertas = () => {
  const [isLanding, setIsLanding] = useState(false)
  const location = useLocation()

  useEffect(() => {
    // Check if the current path is the landing page
    const currentPathMatch = location.pathname === '/landing'
    setIsLanding(currentPathMatch)
  }, [location])

  if (isLanding) {
    return null // Do not render the component on the landing page
  }

  return (
    <>
      <a style={{ bottom: '90px' }} rel='noreferrer' target='_blank' href='https://drive.google.com/drive/folders/1My_SpaoCH0C1lcZ73fGrHTkHoNaiB4-g?usp=share_link' className='ofertasBubble'>
        ¡Novedades!
        <span />
        <span />
      </a>
      <Link to='/productos/precios' className='ofertasBubble'>
        ¡Lista de Precios!
        <span />
        <span />
      </Link>
    </>
  )
}

export default Ofertas
